import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { dAPI } from 'appSrc/api';
import ReactModal from 'react-modal';
import { showModal, hideModal } from 'appSrc/redux/actions';
import { XIcon, FormIcon, PrimaryButton } from 'appSrc/components/UI';
import style from './styles/style.module.css';


class ProRegistrationCompleteModal extends PureComponent {
    constructor( props ) {
        super( props );
        this.state = {
            sendEmails: true,
        };
    }
    toggleSendEmails = ( newVal ) => {
        this.setState( { sendEmails: newVal } );
    }
    submitHandler = () => {
        if( this.state.sendEmails && this.props.emailAddress ) {
            this.props.signUpUser( this.props.emailAddress );
        }
        this.props.showModal( 'listCreationModal', { initialStep: 0 } );
    }
    render() {
        const { modalName, modalProps } = this.props;
        const isOpen = modalName === 'proRegistrationCompleteModal' && modalProps.modalIsOpen;

        return (
            <ReactModal
            isOpen={ isOpen }
            contentLabel="Register"
            onRequestClose={ this.props.closeModal }
            className={ `modal-popup ${ style.proRegistrationCompleteModal }` }
            overlayClassName='modal-overlay' >
                <div className='close-button' onClick={ this.props.closeModal }>
                    <XIcon size={ 24 } />
                </div>
                <div className={ style.contentWrapper } data-hook='registration-modal'>
                    <FormIcon size={ 80 } />
                    <div className={ style.formTitle }>
                        <h3>DONE AND DONE!</h3>
                        <p>Thanks for applying! Your job here is… DONE. (Third time’s a charm ;))
                            <br/><br/>
                        Hold tight while we review your application. The second we’re finished, you’ll receive an email with more details.
                            <br/><br/>
                        Till then, no need to wait. START LISTING</p>
                    </div>

                    <label>
                        <input type='checkbox' checked={ this.state.sendEmails } onChange={ ()=>{ this.toggleSendEmails( !this.state.sendEmails ); } } />
                        <p>Keep me posted on DL updates + Pro tips! (We won’t flood your inbox, promise.)</p>
                    </label>

                    <PrimaryButton
                    label={ 'LET\'S DO THIS' }
                    fullWidth
                    onClick={ this.submitHandler } />

                    <p>If you opt out of marketing emails, we will still send you any important emails regarding your account.</p>
                </div>
            </ReactModal>
        );
    }
}
ProRegistrationCompleteModal.propTypes = {
    closeModal: PropTypes.func,
    emailAddress: PropTypes.string,
    signUpUser: PropTypes.func,
    showModal: PropTypes.func,
};


const mapStateToProps = ( state ) => {
    return {
        modalName: state.modal.modalName,
        modalProps: state.modal.modalProps,
        emailAddress: state.self.user.emailAddress,
    };
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        showModal: ( modalName, options ) => {
            dispatch( showModal( modalName, options ) );
        },
        closeModal: () => {
            dispatch( hideModal( 'proRegistrationCompleteModal' ) );
        },
        signUpUser: ( emailAddress ) => {
            return dAPI.post( '/email/signup', {
                emailAddress: emailAddress,
            } );

        },
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( ProRegistrationCompleteModal );
